<script>
    import { goto, redirect, page } from '@sveltech/routify'
    import { onMount } from 'svelte'
    import AuthService from '../helpers/AuthService'

    /* purgecss start ignore */
    import { Jellyfish } from 'svelte-loading-spinners'
    /* purgecss end ignore */
    let user

    async function checkLogin() {
        // attempt to reauthenticate if the user
        if ($page.path !== '/index') {
            return false
        }

        const res = await authenticate()
        if (!res) {
            await AuthService.removeToken()
        }
        if (res.user) {
            $redirect('/settings')
        }
        return true
    }
    async function authenticate() {
        const auth = AuthService.reAuthFromToken()
        return auth
    }
</script>

{#await checkLogin()}
    <div
        class="absolute left-0 top-0 h-screen w-screen flex items-center justify-center">
        <Jellyfish size="100" />
    </div>
{:then}
    <main>
        <slot />
    </main>
{/await}

<style>
</style>
